module.exports = __webpack_public_path__ + "img/gachita_4_1.a5769832.png";